// frontend/src/components/TopMenu.js
import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useI18n } from '../i18n';
import './TopMenu.css';

/**
 * TopMenu (controlled via props.open / props.onClose).
 * Keeps the original route map and close-on-navigation behavior.
 */
export default function TopMenu({ open = false, onClose = () => {} }) {
  const ref = useRef();
  const navigate = useNavigate();
  const { t } = useI18n();

  useEffect(() => {
    const handleOutside = (event) => {
      if (!open) return;
      if (ref.current && !ref.current.contains(event.target)) {
        onClose();
      }
    };

    if (open) document.addEventListener('mousedown', handleOutside);
    return () => document.removeEventListener('mousedown', handleOutside);
  }, [open, onClose]);

  if (!open) return null;

  const handleNavigate = (path) => {
    navigate(path);
    setTimeout(() => {
      try {
        onClose();
      } catch (_) {}
    }, 0);
  };

  return (
    <div className="topmenu-container" ref={ref} role="menu" aria-label={t('nav.mainMenu')}>
      <nav className="topmenu-list">
        <button className="topmenu-item s1" onClick={() => handleNavigate('/')}>
          <span className="topmenu-badge">I</span>
          <span className="topmenu-label">{t('nav.home')}</span>
        </button>

        <hr className="menu-divider" />

        <button className="topmenu-item s2" onClick={() => handleNavigate('/conciencia')}>
          <span className="topmenu-badge">C</span>
          <span className="topmenu-label">{t('common.consciousness')}</span>
        </button>

        <button className="topmenu-item s2" onClick={() => handleNavigate('/ensonacion')}>
          <span className="topmenu-badge">E</span>
          <span className="topmenu-label">{t('common.reverie')}</span>
        </button>

        <button className="topmenu-item s2" onClick={() => handleNavigate('/subconciencia')}>
          <span className="topmenu-badge">S</span>
          <span className="topmenu-label">{t('common.subconsciousness')}</span>
        </button>

        <button className="topmenu-item s-violet" onClick={() => handleNavigate('/tareas')}>
          <span className="topmenu-badge">T</span>
          <span className="topmenu-label">{t('common.tasks')}</span>
        </button>

        <button className="topmenu-item s-violet" onClick={() => handleNavigate('/lugares')}>
          <span className="topmenu-badge">L</span>
          <span className="topmenu-label">{t('nav.places')}</span>
        </button>

        <button className="topmenu-item s4" onClick={() => handleNavigate('/profile')}>
          <span className="topmenu-badge">P</span>
          <span className="topmenu-label">{t('common.profile')}</span>
        </button>

        <hr className="menu-divider" />

        <button className="topmenu-item s3" onClick={() => handleNavigate('/network')}>
          <span className="topmenu-badge">R</span>
          <span className="topmenu-label">{t('nav.qNetwork')}</span>
        </button>

        <button className="topmenu-item s3" onClick={() => handleNavigate('/qoph')}>
          <span className="topmenu-badge">Q</span>
          <span className="topmenu-label">{t('common.oracle')}</span>
        </button>

        <hr className="menu-divider" />

        <div className="topmenu-item s4" onClick={() => handleNavigate('/profile/gallery')}>
          <span className="topmenu-badge">G</span>
          <span className="topmenu-label">{t('common.gallery')}</span>
          <button
            className="topmenu-camera-btn"
            onClick={(event) => {
              event.stopPropagation();
              handleNavigate('/ajustes#planes-imagenes');
            }}
            title={t('nav.imageSettings')}
            aria-label={t('nav.imageSettings')}
          >
            📷
          </button>
        </div>

        <button className="topmenu-item s4" onClick={() => handleNavigate('/questionnaire')}>
          <span className="topmenu-badge">?</span>
          <span className="topmenu-label">{t('common.questionnaire')}</span>
        </button>

        <hr className="menu-divider" />

        <button className="topmenu-item s-hyper" onClick={() => handleNavigate('/hiperstision')}>
          <span className="topmenu-badge">H</span>
          <span className="topmenu-label">{t('nav.hyperstition')}</span>
        </button>

        <button className="topmenu-item s5" onClick={() => handleNavigate('/ajustes')}>
          <span className="topmenu-badge">⚙</span>
          <span className="topmenu-label">{t('common.settings')}</span>
        </button>
      </nav>
    </div>
  );
}
